<template>
  <b-form>
    <b-row>
      <b-col
        sm="12"
        md="8"
      >
        <b-card>
          <b-card-text>
            <b-row>
              <b-col
                sm="12"
                md="6"
              ><h6 class="mb-1">
                Teklif Oluştur
              </h6></b-col>
            </b-row>
            <b-form-group label="Müşteri Kartı">
              <v-select
                v-model="id_customers"
                label="name"
                :filterable="false"
                :options="customers"
                placeholder="Müşteri Kartı"
                @search="onCustomersSearch"
              >
                <template slot="no-options">
                  Firma Adı, İlgili Kişi, Telefon, Müşteri Kodu...
                </template>
                <template
                  slot="option"
                  slot-scope="customer"
                >
                  <div
                    v-if="customer.company"
                  >
                    <span class="ml-1">{{ customer.company }}</span>
                  </div>
                  <div
                    v-if="customer.name"
                  >
                    <span class="ml-1">{{ customer.name }}</span>
                  </div>
                </template>
                <template
                  slot="selected-option"
                  slot-scope="customer"
                >
                  <div
                    v-if="customer.company"
                    class="selected"
                  >
                    {{ customer.company }}
                  </div>
                  <div
                    v-else
                    class="selected"
                  >
                    {{ customer.name }}
                  </div>
                </template>
              </v-select>
            </b-form-group>
            <b-row>
              <b-col
                sm="12"
                md="6"
              >
                <b-form-group label="Teklif No">
                  <b-form-input
                    v-model="formData.onum"
                    placeholder="Teklif No"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
                md="6"
              >
                <b-form-group label="Teklif Tarihi">
                  <b-form-datepicker
                    id="example-i18n-picker"
                    v-model="formData.odate"
                    v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
                    locale="tr"
                    start-weekday="1"
                    class="mb-1"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group label="Teklif Başlık">
              <b-form-input
                v-model="formData.title"
                placeholder="Teklif Başlık"
              />
            </b-form-group>
            <b-form-group label="İlgili Kişi">
              <b-form-input
                v-model="formData.name"
                placeholder="İlgili Kişi"
              />
            </b-form-group>
            <b-row>
              <b-col
                sm="12"
                md="4"
              >
                <b-form-group label="Teslim Süresi">
                  <b-form-input
                    v-model="formData.delivery_time"
                    placeholder="Teslim Süresi"
                  />
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
                md="4"
              >
                <b-form-group label="Teslim Yeri">
                  <b-form-input
                    v-model="formData.delivery_location"
                    placeholder="Teslim Yeri"
                  />
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
                md="4"
              >
                <b-form-group label="Ödeme">
                  <b-form-input
                    v-model="formData.payment"
                    placeholder="Ödeme"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
        <b-card>
          <b-card-text>
            <b-row>
              <b-col
                sm="12"
                md="6"
              ><h6 class="mb-1">
                Teklif İçeriği
              </h6></b-col>
            </b-row>
            <div v-if="formData.products.length > 0">
              <b-row
                v-for="(product,key) in formData.products"
                :key="key"
                class="mb-2"
              >
                <b-col md="12">
                  <b-form-group label="Ürün Seçimi">
                    <v-select
                      v-model="product.id_products"
                      label="name"
                      :filterable="false"
                      :clearable="false"
                      :options="products"
                      @search="onProductsSearch"
                    >
                      <template slot="no-options">
                        Ürün Kodu, Ürün Adı...
                      </template>
                      <template
                        slot="option"
                        slot-scope="product"
                      >
                        <div
                          v-if="product.pcode"
                        >
                          <span class="ml-1"><strong>Ürün Kodu:</strong> {{ product.pcode }}</span>
                        </div>
                        <div
                          v-if="product.title"
                        >
                          <span class="ml-1">{{ product.title }}</span>
                        </div>
                        <div
                          v-if="product.list_price"
                        >
                          <span class="ml-1 text-danger"><strong>Liste Fiyatı:</strong> {{ product.list_price }} {{ product.currency }}</span>
                        </div>
                      </template>
                      <template
                        slot="selected-option"
                        slot-scope="product"
                      >
                        <div class="selected">
                          {{ product.pcode }} {{ product.title }}
                        </div>
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="product.id_products"
                  sm="12"
                  md="4"
                >
                  <b-form-group label="Ürün Kodu">
                    <b-form-input
                      v-model="product.id_products.pcode"
                      placeholder="Ürün Kodu"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  md="8"
                >
                  <b-form-group label="Ürün Adı">
                    <b-form-input
                      v-model="product.id_products.title"
                      placeholder="Ürün Adı"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  md="4"
                >
                  <b-form-group label="Miktar">
                    <b-form-input
                      v-model="product.id_products.quantity"
                      placeholder="Miktar"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  md="8"
                >
                  <b-form-group label="Birim">
                    <v-select
                      v-model="product.id_products.id_units"
                      label="title"
                      :reduce="unit => unit.id"
                      placeholder="Birim"
                      :options="units"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  md="4"
                >
                  <b-form-group label="Malzeme Birim Fiyatı">
                    <cleave
                      v-model="product.id_products.list_price"
                      class="form-control"
                      :raw="true"
                      :options="maskOptions.number"
                      placeholder="Malzeme Birim Fiyatı"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  md="4"
                >
                  <b-form-group label="İşçilik Fiyatı">
                    <cleave
                      v-model="product.id_products.labor_price"
                      class="form-control"
                      :raw="true"
                      :options="maskOptions.number"
                      placeholder="İşçilik Fiyatı"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                  md="4"
                >
                  <b-form-group label="Para Birimi">
                    <v-select
                      v-model="product.id_products.id_currencies"
                      label="title"
                      :reduce="currency => currency.id"
                      placeholder="Para Birimi"
                      :options="currencies"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="product.id_products.rowTotal > 0"
                  sm="12"
                  md="6"
                >
                  <b-form-group
                    label="İskonto Tutarı"
                  >
                    <b-input-group
                      :prepend="product.id_products.currencySymbol"
                    >
                      <cleave
                        v-model="product.id_products.discount_price"
                        class="form-control"
                        :raw="true"
                        :options="maskOptions.number"
                        placeholder="İskonto Tutarı"
                      />
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="product.id_products.rowTotal > 0"
                  sm="12"
                  md="6"
                >
                  <b-form-group
                    label="İskonto Oranı"
                  >
                    <b-input-group
                      prepend="%"
                    >
                      <b-form-input
                        v-model="product.id_products.discount_rate"
                        placeholder="İskonto Oranı"
                      />
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="Toplam Tutar">
                    <b-input-group>
                      <cleave
                        :value="calcRowTotal(product.id_products,key)"
                        class="form-control"
                        :raw="true"
                        :options="maskOptions.number"
                        placeholder="Toplam Tutar"
                        readonly
                      />

                      <b-input-group-append>
                        <b-button
                          variant="outline-danger"
                          @click="removeProduct(key)"
                        >
                          <FeatherIcon icon="XIcon" /> ÜRÜNÜ SİL</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <hr>
                </b-col>
              </b-row>
            </div>
            <b-row v-else>
              <b-col md="12">
                <b-alert
                  variant="primary"
                  show
                >
                  <div class="alert-body text-center">
                    <span>Henüz hiç ürün eklenmemiş. Teklifinizi oluşturmak için ürün ekleyin.</span>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  pill
                  @click="addProduct"
                >
                  <FeatherIcon icon="PlusIcon" />
                  Ürün Ekle
                </b-button>
              </b-col>
            </b-row>
          </b-card-text>

        </b-card>
        <b-card>
          <b-card-text>
            <b-row>
              <b-col md="12">
                <b-form-group label="Özel Şartlar Şablonları">
                  <v-select
                    v-model="id_offer_terms"
                    label="title"
                    placeholder="Şablon Seçin"
                    :options="offerTerms"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="12"
              ><h6 class="mb-1">
                Özel Şartlar
              </h6></b-col>
              <b-col md="12">
                <quill-editor
                  v-model="formData.terms"
                  :options="editorOption"
                  class="bg-white text-black-50"
                >
                  <div
                    id="toolbar"
                    slot="toolbar"
                  >
                    <!-- Add a bold button -->
                    <button class="ql-bold">
                      Bold
                    </button>
                    <button class="ql-italic">
                      Italic
                    </button>
                    <button
                      class="ql-list"
                      value="ordered"
                    />
                    <!-- Add font size dropdown -->
                    <select class="ql-size">
                      <option value="small" />
                      <!-- Note a missing, thus falsy value, is used to reset to default -->
                      <option selected />
                      <option value="large" />
                      <option value="huge" />
                    </select>

                    <select class="ql-font">
                      <option selected="selected" />
                      <option value="serif" />
                      <option value="monospace" />
                    </select>
                    <!-- Add subscript and superscript buttons -->
                    <button
                      class="ql-script"
                      value="sub"
                    />
                    <button
                      class="ql-script"
                      value="super"
                    />
                  </div>
                </quill-editor>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
        <b-button
          variant="danger"
          :disabled="submitStatus"
          @click="submitForm"
        >
          Kaydet
        </b-button>
      </b-col>
      <b-col
        sm="12"
        md="4"
      >
        <offer-summary
          :id_customers="id_customers"
          :form-data="formData"
        />
      </b-col></b-row>
  </b-form>
</template>

<script>
import vSelect from 'vue-select'
import {
  BForm,
  BCard,
  BCardText,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BRow,
  BCol,
  BButton,
  BFormDatepicker,
  BAlert,
  BInputGroupAppend,
} from 'bootstrap-vue'
// eslint-disable-next-line import/extensions
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/extensions
import OfferSummary from '@/views/Offers/components/OfferSummary'
import axiosIns from '@/libs/axios'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
// eslint-disable-next-line import/order
import { quillEditor } from 'vue-quill-editor'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const _ = require('lodash')

export default {
  name: 'Add',
  components: {
    BForm,
    BCard,
    BCardText,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BButton,
    BFormDatepicker,
    vSelect,
    OfferSummary,
    BAlert,
    Cleave,
    BInputGroupAppend,
    BInputGroup,
    quillEditor,
  },
  data() {
    return {
      submitStatus: false,
      formData: {
        onum: null,
        title: null,
        name: null,
        odate: null,
        delivery_time: null,
        delivery_location: null,
        payment: null,
        terms: null,
        id_customers: null,
        products: [],
      },
      maskOptions: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          delimiter: '.',
        },
      },
      editorOption: {
        modules: {
          toolbar: '#toolbar',
        },
        theme: 'snow',
      },
      customers: [],
      products: [],
      id_customers: {},
      id_products: {},
      id_offer_terms: {},
    }
  },
  computed: {
    saveStatus() {
      const status = this.$store.getters['offers/getOfferSaveStatus']
      return status
    },
    units() {
      const data = this.$store.getters['units/getUnits']
      return data
    },
    offerCode() {
      const data = this.$store.getters['offers/getNewOfferCode']
      return data
    },
    currencies() {
      const data = this.$store.getters['currencies/getCurrencies']
      return data
    },
    offerTerms() {
      const data = this.$store.getters['offerTerms/getOffer_terms']
      return data
    },
  },
  watch: {
    saveStatus(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.formData = {
          onum: null,
          title: null,
          odate: null,
          id_customers: null,
          products: [],
        }
        this.$router.push(`/offers/view/${val.id}`)
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.submitStatus = false
    },
    id_customers(val) {
      if (!val) {
        this.customers = []
      } else {
        this.formData.id_customers = val.id
      }
    },
    id_products(val) {
      if (!val) {
        this.products = []
      }
    },
    offerCode(val) {
      if (val) {
        this.formData.onum = val
      }
    },
    id_offer_terms(val) {
      if (val) {
        this.formData.terms = val.content
      }
    },
  },
  created() {
    this.getUnits()
    this.getCurrencies()
    this.getOfferCode()
    this.getOfferTerms()
  },
  mounted() {
    this.createOfferCode()
  },
  methods: {
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
    /* Customer Search Start --> */
    onCustomersSearch(search, loading) {
      if (search.length) {
        loading(true)
        this.customerSearch(loading, search, this)
      }
    },
    customerSearch: _.debounce((loading, search, vm) => {
      const data = JSON.stringify({
        select: [
          'customers.id AS id',
          'customers.ccode AS ccode',
          'customers.company AS company',
          'customers.name AS name',
          'customers.phone AS phone',
          'cities.title AS city',
        ],
        or_like: {
          'customers.ccode': search,
          'customers.company': search,
          'customers.name': search,
          'customers.phone': search,
        },
      })
      axiosIns
        .post('/customers', data)
        .then(response => {
          vm.customers = response.data.data
          loading(false)
        })
        .catch(error => console.error(error))
    }, 350),
    /* <-- Customer Search End */
    /* Products Search Start --> */
    onProductsSearch(search, loading) {
      if (search.length) {
        loading(true)
        this.productSearch(loading, search, this)
      }
    },
    productSearch: _.debounce((loading, search, vm) => {
      const data = JSON.stringify({
        select: [
          'products.id AS id',
          'products.pcode AS pcode',
          'products.title AS title',
          'products.list_price AS list_price',
          'products.labor_price AS labor_price',
          'products.id_currencies AS id_currencies',
          'brands.title AS brand',
          'currencies.symbol AS currency',
          '"" AS quantity',
          '"" AS rowTotal',
          '"" AS currencySymbol',
          '"" AS unit',
          '"" AS id_units',
          '"" AS discount_price',
          '"" AS discount_rate',
        ],
        or_like: {
          'products.pcode': search,
          'products.title': search,
        },
        limit: 50,
      })
      axiosIns
        .post('/products/getData', data)
        .then(response => {
          vm.products = response.data.data
          loading(false)
        })
        .catch(error => console.error(error))
    }, 350),
    /* <-- Products Search End */
    getUnits() {
      this.$store.dispatch('units/unitsList', { select: ['units.id AS id', 'units.title AS title'] })
    },
    getOfferCode() {
      this.$store.dispatch('offers/newOfferCode')
    },
    getCurrencies() {
      this.$store.dispatch('currencies/currenciesList')
    },
    getOfferTerms() {
      this.$store.dispatch('offerTerms/offer_termsList')
    },
    addProduct() {
      const row = {
        id_products: {
          pcode: '',
          title: '',
          quantity: '',
          rowTotal: 0,
          currencySymbol: '',
          unit: '',
          id_units: '',
          list_price: '',
          labor_price: '',
          id_currencies: '',
          discount_price: '',
          discount_rate: '',
        },
      }
      const { products } = this.formData
      products.push(row)
      this.formData.products = products
    },
    removeProduct(key) {
      this.formData.products.splice(key, 1)
    },
    calcRowTotal(data, key) {
      let total = 0
      if (data.quantity) {
        if (data.quantity && data.list_price && data.labor_price) {
          const quantity = Number(data.quantity)
          const listPrice = Number(data.list_price)
          const laborPrice = Number(data.labor_price)
          total = (listPrice + laborPrice) * quantity
        }
        if (data.discount_price) {
          total -= data.discount_price
        }
        if (data.discount_rate) {
          const discount = (total * data.discount_rate) / 100
          total -= discount
        }
        this.formData.products[key].id_products.rowTotal = total
        const { currencies, units } = this
        if (data.id_currencies) {
          this.formData.products[key].id_products.currencySymbol = currencies.find(currency => currency.id === data.id_currencies).symbol
        } else {
          this.formData.products[key].id_products.currencySymbol = ''
        }
        if (data.id_units) {
          this.formData.products[key].id_products.unit = units.find(unit => unit.id === data.id_units).title
        } else {
          this.formData.products[key].id_products.unit = ''
        }
      }
      return total
    },
    createOfferCode() {
      this.formData.onum = this.offerCode
    },
    submitForm() {
      this.submitStatus = true
      this.$store.dispatch('offers/offerSave', this.formData)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
